import React from 'react';
import { COMPANY_INFO } from '../constants/company';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>&copy; 2026 {COMPANY_INFO.name.english} Co., Ltd. All rights reserved.</p>
  </footer>
);

export default Footer;
